import {
  ComponentPropsWithoutRef,
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
} from 'react';
import { text as formText } from '../../form/field/text-input';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;
type FormTextProps = ComponentPropsWithoutRef<typeof formText>;

type Props = Omit<FormTextProps, 'type'>;

export const search: FR<HTMLInputElement, Props> = forwardRef((props, ref) => {
  const { label = 'Buscar', placeholder = 'Buscar' } = props;

  const FormText = formText;

  return <FormText {...props} ref={ref} type="text" label={label} placeholder={placeholder} />;
});

search.displayName = 'SiloReal-Filter-Field-Search';
